<template>
  <div class="container">
    <div class="refund-head trans">
      <refund-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />
      <div class="refund-content">
        <div class="refund-info">
          <h2 class="tit">报名信息</h2>
          <div class="list">
            <div class="item">姓名：{{ currentSignup.name }}</div>
            <div class="item">手机号：{{ currentSignup.phone }}</div>
            <div class="item">参会身份：{{ currentSignup.attendid.name }}</div>
            <div class="item">
              缴费金额：{{ currentSignup.paid_order.paid_prize }}
            </div>
            <div class="item">缴费状态：{{ currentSignup.paid_status }}</div>
          </div>
        </div>
        <div class="refund-reason">
          <h2 class="tit">退费原因</h2>
          <el-input type="textarea" v-model="reason"></el-input>
        </div>
        <el-button class="handleSubmit" @click="handleSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import refundHeader from "@/components/header"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import { UserOrderRecord } from "@/store/entity/pay"

  export default {
    name: "refundPage",
    components: {
      refundHeader,
    },
    mixins: [CurrentUserMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "申请退费",
        },
        reason: "",
      }
    },

    mounted(){
        const reason = this.currentSignup.paid_order.refund_reason;
        if (reason && reason.length > 0) {
          this.reason = reason
        }
    },
    watch: {
      "currentSignup.paid_order.refund_reason": function (reason) {
        // 如果填写过，写入填写的值
        if (reason && reason.length > 0) {
          this.reason = reason
        }
      },
    },

    methods: {
      handleClickIocn() {
        this.$router.go(-1);
      },
      async handleSubmit() {
        console.log(this.currentSignup.paid_status)
        if (
          this.currentSignup.paid_status == "已缴费" ||
          this.currentSignup.paid_status == "申请退费"
        ) {
          const data = {
            trade_no: this.currentSignup.paid_order.trade_no,
            refund_reason: this.reason,
          }
          await UserOrderRecord.createRefund(data)
          // 然后刷新signup状态
          const phone = this.currentSignup.phone
          const conference_id = this.currentSignup.conference_id
          // 因为getSignupInfo是有缓存的，先重置状态再获取
          await this.$store.dispatch("user/resetFetchSignupInfo")
          alert("申请退款成功，请等待审核通知短信。")
          this.$router.go(-1);
        } else {
          alert("未支付完成或者已处理退款")
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .refund-content {
    margin: 0 15px;

    .refund-info,
    .refund-reason {
      margin-top: 30px;

      .tit {
        padding-left: 8px;
        border-left: 4px solid var(--main-color);
        font-size: 16px;
        font-weight: bold;
        color: var(--main-color);
      }
    }

    .list {
      margin-top: 15px;
      background: #fff;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
      padding: 15px;
      border-radius: 5px;
      box-sizing: border-box;

      .item {
        line-height: 30px;
        margin-top: 10px;
        border-bottom: 1px solid #f2f3f3;

        &:first-child {
          margin-top: 0;
        }
      }
    }

    ::v-deep .el-textarea__inner {
      margin-top: 15px;
      height: 80px;
      &:focus {
        border-color: var(--main-color);
      }
    }

    .handleSubmit {
      width: 100%;
      margin-top: 30px;
      background: var(--main-color);
      color: #fff;
    }
  }
</style>
